import React from 'react';

interface MetricCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  gradient: string;
  subtitle: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  gradient,
  subtitle
}) => {
  return (
    <div
      className="metric-card"
      style={{
        background: gradient
      }}
    >
      <div className="flex items-center gap-4 w-full">
        <div className="metric-icon">{icon}</div>
        <div className="w-full flex flex-col gap-2">
          <p className="text-[16px] font-semibold text-white leading-[20px]">
            {title}
          </p>
          <div className="w-full h-[1px] bg-white/50"></div>
        </div>
      </div>

      <p className="text-[32px] font-semibold text-white leading-normal flex justify-end">
        {value}
      </p>

      <p className="text-[13px] font-medium text-white/90 leading-normal">
        {subtitle}
      </p>
    </div>
  );
};

export default MetricCard;

